<template>
    <collapsible-card :title="'Permit to Modify'" v-show="showPermit" ref="cCard">
        <div class="cardContent">
            <table class="dynamicTable">
                <thead>
                    <tr class="dynamic3ColExpand">
                        <th scope="col">Well ID</th>
                        <th scope="col">Operator</th>
                        <th scope="col">Work Begin Date</th>
                    </tr>
                </thead>
                <tbody>
                    <lease-modify-permit-item v-for="(obj, index) in modifyPermit" :key="index" :modifyPermitItem="obj" />
                </tbody>
            </table>
        </div>
    </collapsible-card>
</template>

<script>
import LeaseModifyPermitItem from './LeaseModifyPermitItem.vue';
import CollapsibleCard from '../CollapsibleCard';

export default {
    name: 'lease-modify-permit',
    components: {
        LeaseModifyPermitItem,
        CollapsibleCard
    },
    data: () => ({
        showPermit: false,
        modifyPermit: [],
    }),
    methods: {
        updateInfo: function(modifyPermit) {
            var globv = this;

            if (modifyPermit.length > 0) {
                globv.modifyPermit = modifyPermit;
                globv.showPermit = true;
                globv.$refs.cCard.adjustHeight();
            }
        },
        reset: function() {
            var globv = this;
            globv.showPermit= false;
            globv.modifyPermit = [];
        }
    }
}
</script>